// extracted by mini-css-extract-plugin
module.exports = {"textInput":"Conversation_textInput__zArVI","messagesContainer":"Conversation_messagesContainer__ixRel","spaceConsumer":"Conversation_spaceConsumer__ghAp3"};